import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

import ListIcon from '@material-ui/icons/List';
import MapIcon from '@material-ui/icons/MyLocation';
import {
  AzureIcon,
  AwsIcon,
  AzureDevOpsIcon
} from '../../assets/icons/AzureIcons';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="catalog" text="Home" />
        {/*TODO variabilize azure sidebar items showing or not */}
        <SidebarItem icon={AzureIcon} to="catalog?filters[kind]=resource&filters[tags]=azure" text="Azure" />
        <SidebarItem icon={AwsIcon} to="catalog?filters[kind]=resource&filters[tags]=aws" text="Aws" />
        <SidebarItem icon={AzureDevOpsIcon} to="catalog?filters[kind]=component" text="DevOps" />
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
        <SidebarItem icon={ListIcon} to="create/tasks" text="Tasks" />
        <SidebarItem icon={CreateComponentIcon} to="create?filters[tags]=latest&filters[tags]=create" text="Create..." />
        {/* End global nav */}
        <SidebarDivider />
        <SidebarScrollWrapper>
          <SidebarItem icon={MapIcon} to="tech-radar" text="Tech Radar" />
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);



// export const Root = ({ children }: PropsWithChildren<{}>) => (
//   <SidebarPage>
//     <Sidebar>
//       <SidebarLogo />
//       <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
//         <SidebarSearchModal />
//       </SidebarGroup>
//       <SidebarDivider />
//       <SidebarGroup label="Menu" icon={<MenuIcon />}>
//         {/* Global nav, not org-specific */}
//         <SidebarItem icon={HomeIcon} to="catalog" text="Home" />
//         <MyGroupsSidebarItem
//           singularTitle="My Group"
//           pluralTitle="My Groups"
//           icon={GroupIcon}
//         />
//         <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
//         <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
//         <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
//         {/* End global nav */}
//         <SidebarDivider />
//         <SidebarScrollWrapper>
//           {/* Items in this group will be scrollable if they run out of space */}
//         </SidebarScrollWrapper>
//       </SidebarGroup>
//       <SidebarSpace />
//       <SidebarDivider />
//       <SidebarGroup
//         label="Settings"
//         icon={<UserSettingsSignInAvatar />}
//         to="/settings"
//       >
//         <SidebarSettings />
//       </SidebarGroup>
//     </Sidebar>
//     {children}
//   </SidebarPage>
// );
